const initialState = {}

const activities = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'ACTIVITIES.INIT':
      return {...state, ...payload}
    default:
      return state
  }
}

export default activities
